import React from 'react';
import { View, Pressable } from 'react-native';
import { Controller } from 'react-hook-form';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { StyledTextInput } from 'app/src/elements/inputs';
import { Text } from 'app/src/styles';

const Inputs = styled(View)`
  flex-direction: row;
  align-items: baseline;
  gap: 10px;
`;

const Label = styled(Text)`
`;

const ScheduleLineInput = ({ control, index, remove }) => {
  return (
    <Inputs>
      <Label>Start Price</Label>
      <Controller
        control={control}
        name={`schedule.${index}.start`}
        rules={{ required: true }}
        render={({ field }) => (
          <StyledTextInput
            style={{ width: 80 }}
            {...field}
            onChangeText={value => field.onChange(parseInt(value) || '')}
          />
        )}
      />
      <Label>Default Step</Label>
      <Controller
        control={control}
        name={`schedule.${index}.defaultStep`}
        rules={{ required: true }}
        render={({ field }) => (
          <StyledTextInput
            style={{ width: 80 }}
            {...field}
            onChangeText={value => field.onChange(parseInt(value) || '')}
          />
        )}
      />
      <Label>Minimum Step</Label>
      <Controller
        control={control}
        name={`schedule.${index}.minStep`}
        rules={{ required: true }}
        render={({ field }) => (
          <StyledTextInput
            style={{ width: 80 }}
            {...field}
            onChangeText={value => field.onChange(parseInt(value) || '')}
          />
        )}
      />
      <Pressable onPress={remove}>
        <FontAwesomeIcon
          icon={faTrash}
          style={{color: 'red'}}
          title="Remove"
        />
      </Pressable>
    </Inputs>
  );
};

export default ScheduleLineInput;
